var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMuteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lyd_av_p\\xE5_small",
    "data-name": "Lyd av/p\\xE5 small",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.768,
    height: 25.46,
    viewBox: "0 0 23.768 25.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M25.109,28.84a.859.859,0,0,1-.747-.428L10.507,4.68A.864.864,0,1,1,12,3.81L25.856,27.543a.861.861,0,0,1-.747,1.3Z",
    transform: "translate(-4.463 -3.38)",
    fill: "#4b2f3e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M8.735,13.7H5.482a.981.981,0,0,0-.982.982v4.91a.985.985,0,0,0,.982.982H8.735l4.014,3.222a1,1,0,0,0,.62.215.932.932,0,0,0,.423-.1.982.982,0,0,0,.558-.884V15.409l-2.486-4.222Z",
    transform: "translate(-4.5 -5.015)",
    fill: "#4b2f3e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M30.742,16.59h0a13.421,13.421,0,0,0-4.028-9.624.739.739,0,1,0-1.039,1.052,11.937,11.937,0,0,1,3.591,8.573h0A11.962,11.962,0,0,1,26.7,24.019l.8,1.353a13.4,13.4,0,0,0,3.241-8.782Z",
    transform: "translate(-6.974 -4.58)",
    fill: "#4b2f3e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M26.488,16.953h0A9.989,9.989,0,0,0,23.6,9.889a.739.739,0,1,0-1.051,1.039,8.513,8.513,0,0,1,2.459,6.03h0a8.59,8.59,0,0,1-.854,3.762l.873,1.481A10.087,10.087,0,0,0,26.488,16.953Z",
    transform: "translate(-6.574 -4.944)",
    fill: "#4b2f3e"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M21.792,17.145h0A6.141,6.141,0,0,0,20.015,12.8a.711.711,0,0,0-1.007-.006.866.866,0,0,0-.095.112l2.848,4.843C21.78,17.548,21.792,17.346,21.792,17.145Z",
    transform: "translate(-6.025 -5.312)",
    fill: "#4b2f3e"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuteIcon);
export default __webpack_public_path__ + "static/media/mute-icon.dac3cae39dbe66afbb0c617c2f0fccf1.svg";
export { ForwardRef as ReactComponent };